import React, { useState } from 'react';
import { Grid, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import { CloseOutlined } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import { showSalesBanner } from '../../utils/user';
import { LocalStorage } from '../../enums/LocalStorage';

const useStyles = makeStyles((theme: Theme) => ({
   container: {
     backgroundColor: theme.palette.primary.main,
     fontSize: "1.3rem",
     padding: "1rem 2rem",
     position: "relative"
   },
   content: {
     textAlign: "center"
   },
  close: {
    position: "absolute", top: 10, right: 10, cursor: 'pointer'
  }
}))


export const SaleBanner: React.FC<any> = () => {
  const styles = useStyles();
  const userData = useSelector((state: any) => state.userData)
  const [shouldShow, setShouldShow] = useState(showSalesBanner(userData.userType));
  const couponCode = "APR25OFFSPDS";

  function closebanner() {
    setShouldShow(false);
    localStorage.setItem(LocalStorage.SALES_BANNER, "true");
  }

  if (!shouldShow) {
    return null;
  }

 return (
   <Grid container className={styles.container} justify={"center"} alignItems={"center"}>
      <CloseOutlined className={styles.close} onClick={closebanner}></CloseOutlined>
      <Grid item className={styles.content}>
        <p>
          Get 25% off our class plan! Use coupon code <b>{couponCode}</b> at checkout.
        </p>
        <p>
          Sale ends {moment("2021-05-16").format("MMMM DD, YYYY")} <b>Available for purchase in dashboard only.</b>
        </p>
      </Grid>
   </Grid>
 )
}
